import React from 'react';
import {Button, InputNumber} from 'antd';
import './AmountSelector.css';

interface AmountSelectorProps {
    selectedPercent: number;
    onPercentChange: (percent: number) => void;
    availableMarginUsdt?: number | null;
    isLoading?: boolean;
    minOrderMarginUsdt?: number;
}

const QUICK_BUTTONS = [5, 10, 15, 25];

const AmountSelector: React.FC<AmountSelectorProps> = ({
                                                           selectedPercent,
                                                           onPercentChange,
                                                           availableMarginUsdt,
                                                           isLoading = false,
                                                           minOrderMarginUsdt = 5
                                                       }) => {
    const hasAvailableMargin = availableMarginUsdt !== null
        && availableMarginUsdt !== undefined
        && Number.isFinite(availableMarginUsdt);
    const estimatedMargin = hasAvailableMargin
        ? availableMarginUsdt * (selectedPercent / 100)
        : null;
    const isBelowMinimum = hasAvailableMargin && estimatedMargin! < minOrderMarginUsdt;
    const formatUsdt = (value: number) => value.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });

    return (
        <div className="amount-selector amount-selector--percent" style={{width: '100%'}}>
            <div className="amount-selector__body" style={{width: '100%'}}>
                <div className="amount-selector__controls">
                    <div className="amount-selector__input-row">
                        <span>开仓比例</span>
                        <InputNumber<number>
                            className="amount-selector__input"
                            value={selectedPercent}
                            onChange={(value) => {
                                if (value !== null) onPercentChange(value);
                            }}
                            min={0.01}
                            max={25}
                            step={0.1}
                            precision={2}
                            size="small"
                            controls={true}
                            formatter={(value) => `${value}%`}
                            parser={(value) => parseFloat(value?.replace('%', '') || '0')}
                        />
                    </div>
                    <div className="amount-selector__presets" aria-label="常用开仓比例">
                        {QUICK_BUTTONS.map((pct) => (
                            <Button
                                key={pct}
                                size="small"
                                className="amount-selector__preset"
                                type={selectedPercent === pct ? 'primary' : 'default'}
                                onClick={() => onPercentChange(pct)}
                            >
                                {pct}%
                            </Button>
                        ))}
                    </div>
                </div>
                <div className="amount-selector__valuation" aria-live="polite">
                    {hasAvailableMargin ? <>
                        <div className="amount-selector__metric">
                            <span>可用</span>
                            <strong>{formatUsdt(availableMarginUsdt)} USDT</strong>
                        </div>
                        <div
                            className={'amount-selector__metric amount-selector__metric--primary' + (isBelowMinimum ? ' amount-selector__metric--below-min' : '')}>
                            <span>本次保证金</span>
                            <strong>{formatUsdt(estimatedMargin!)} USDT</strong>
                        </div>
                        <div
                            className={'amount-selector__rule' + (isBelowMinimum ? ' amount-selector__rule--warn' : '')}>最低 {minOrderMarginUsdt} USDT
                        </div>
                    </> : <div className="amount-selector__empty">
                        {isLoading ? '正在获取可用保证金' : '选择账户后显示金额'}
                    </div>}
                </div>
            </div>
        </div>
    );
};

export default AmountSelector;
